import { AsyncStatus } from '../types';
import {
  REQUEST_APP_INITIALIZER,
  REQUEST_WEATHER_DATA,
  RECEIVE_WEATHER_DATA,
  FAILURE_WEATHER_DATA,
  REQUEST_WEATHER_OBSERVATIONS,
  RECEIVE_WEATHER_OBSERVATIONS,
  FAILURE_WEATHER_OBSERVATIONS,
} from '../constants/actionTypes';
import { processGdu } from '../utils/weatherData';
import { WeatherState } from '../actions/weather/types/state'; 

export const initialState: WeatherState = {
  precipitation: {},
  precipitationStatus: AsyncStatus.IDLE,
  gdus: {},
  gdusStatus: AsyncStatus.IDLE
};

/**
 * Handles redux state for weather data
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
function weatherReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_APP_INITIALIZER: {
      return initialState;
    }

    case REQUEST_WEATHER_DATA: {
      return {
        ...state,
        precipitationStatus: AsyncStatus.PENDING
      }
    }

    case RECEIVE_WEATHER_DATA: {
      if (
        action.data &&
        action.data.length &&
        action.data[0].value &&
        action.data[0].value.precip
      ) {
        const precip = action.data[0].value.precip.q;
        const result = precip.reduce((dates, value, index) => {
          const date = new Date(action.data[0].value.start_date);
          date.setDate(date.getDate() + index);
          const [dateString] = date.toISOString().split('T');
          return {
            ...dates,
            [dateString]: value,
          };
        }, {});

        return {
          ...state,
          precipitation: result,
          precipitationStatus: AsyncStatus.RESOLVED
        };
      }

      return {
        ...state,
        precipitationStatus: AsyncStatus.RESOLVED
      };
    }


    case FAILURE_WEATHER_DATA: {
      return {
        ...state,
        precipitationStatus: AsyncStatus.REJECTED
      };
    }


    case REQUEST_WEATHER_OBSERVATIONS: {
      return {
        ...state,
        gdusStatus: AsyncStatus.PENDING
      }
    }

    case RECEIVE_WEATHER_OBSERVATIONS: {
      const { response, season, useMicrosoftGDD } = action;
      const { results } = response;
      const year = season.split(':')[0];

      if (!results?.length) return { ...state };

      if (useMicrosoftGDD) {
        const gdusBySeason = results.reduce((acc, v) => {
          const seasonTag = v.season_tag;
          acc[seasonTag] = processGdu(v, year);
          return acc;
        }, {});

        return {
          ...state,
          gdus: gdusBySeason,
          gdusStatus: AsyncStatus.RESOLVED
        };
      }

      return {
        ...state,
        gdus: processGdu(results[0], year),
        gdusStatus: AsyncStatus.RESOLVED
      };
    }

    case FAILURE_WEATHER_OBSERVATIONS: {
      return {
        ...state,
        gdusStatus: AsyncStatus.REJECTED
      };
    }

    default:
      return state;
  }
}

export default weatherReducer;
